import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=70a46fdc&scoped=true"
import script from "./BrandManage.vue?vue&type=script&lang=js"
export * from "./BrandManage.vue?vue&type=script&lang=js"
import style0 from "./BrandManage.vue?vue&type=style&index=0&id=70a46fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a46fdc",
  null
  
)

export default component.exports